import { Observable } from 'rxjs';
import { IGetGateway, ISaveGateway } from '../gateways';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { ILicense, LICENSES_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';

export class LicenseGateway
  implements
    IGetGateway<null, IApiResponse<ILicense[]>>,
    ISaveGateway<ILicense[], IApiResponse<ILicense[]>>
{
  private readonly restCallBuilder: RestCallBuilder<ILicense[]> =
    new RestCallBuilder<ILicense[]>([]);

  get(): Observable<IApiResponse<ILicense[]>> {
    return this.restCallBuilder
      .get('/licenses/')
      .validate(API_RESPONSE_SCHEMA(LICENSES_SCHEMA), 'License.get')
      .handleMessages()
      .build();
  }

  save(query: ILicense[]): Observable<IApiResponse<ILicense[]>> {
    return this.restCallBuilder
      .post('/licenses/', query)
      .validate(API_RESPONSE_SCHEMA(LICENSES_SCHEMA), 'License.save')
      .handleMessages()
      .build();
  }
}
